// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
  message: {
    PrivacyPolicy: '隐私政策',
    my: '我的',
    Loading:'加载中...',
    Todo_Total:"共有",
    Todo_Tasks:"项任务",
    Nothing:"暂无任务",
    pullingText:"下拉可刷新",
    loosingText:"释放可刷新",
  },
  error:{
    
  },
}
